// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aggregated-fields-dialog .mdc-data-table{width:100%}`, "",{"version":3,"sources":["webpack://./src/agElements/overview-aggregation-component/aggregated-fields-dialog/aggregated-fields-dialog.scss"],"names":[],"mappings":"AAAA,0CAA0C,UAAU","sourcesContent":[".aggregated-fields-dialog .mdc-data-table{width:100%}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
